import { render } from "./Fintech.vue?vue&type=template&id=48bf0b64&lang=true"
import script from "./Fintech.vue?vue&type=script&lang=js"
export * from "./Fintech.vue?vue&type=script&lang=js"

import "./Fintech.vue?vue&type=style&index=0&id=48bf0b64&lang=scss&scooped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__